import axios from "axios";

export const PERSONNEL_TYPE_URL = "/PersonnelType";

/** Belli Bir Personel Türü Listesini Elde Eder */
export function getPersonnelTypes(queryParams) {
  return axios.post(`${PERSONNEL_TYPE_URL}/GetPersonnelTypes`, queryParams);
}

/** Belli Bir Personel Türü Listesini Sayfalama Olmadan Elde Eder */
export function getAllPersonnelTypes(queryParams) {
  return axios.post(`${PERSONNEL_TYPE_URL}/GetAllPersonnelTypes`, queryParams);
}

/** Yeni Bir Personel Türü Elde Eder */
export function getNewPersonnelType() {
  return axios.get(PERSONNEL_TYPE_URL);
}

/** Belli Bir Personel Türünü Elde Eder */
export function getPersonnelType(id) {
  return axios.get(`${PERSONNEL_TYPE_URL}/${id}`);
}

/** Belli Bir Personel Türünü Kaydeder */
export function savePersonnelType(personnelType) {
  return axios.post(PERSONNEL_TYPE_URL, personnelType);
}

/** Belli Bir Personel Türü Listesini Siler */
export function deletePersonnelTypes(ids) {
  return axios.post(`${PERSONNEL_TYPE_URL}/Delete`, { ids });
}